export class PageInfo {
  pageIndex: number;
  pageSize: number;
  totalRecords: number;

  constructor() {
    this.pageIndex = 1;
    this.pageSize = 10;
    this.totalRecords = 0;
  }
  firstPage(): number {
    let num = 1;
    return num;
  }
  lastPage(): number {
    let num = 1;
    const divide = Math.ceil(this.totalRecords / this.pageSize);
    if (divide >= 1) num = divide;
    return num;
  }
  calculagePageIndex(rowIndex: number): number {
    const index = Math.ceil(rowIndex / this.pageSize);
    return index + 1;
  }
}
